import React from 'react'
import styled from 'styled-components'
import { ecosystemList } from '../list'
import HyperswapLogo from '../../../../assets/logo-white.svg'
import Tag from 'components/Tag'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 12px;
  border-radius: 12px;

  transition: background 200ms;
  &:hover {
    background: ${({ theme }) => theme.bg1};
  }

  @media (max-width: 768px) {
    padding: 8px;
  }

  background: ${({ theme }) => theme.bg2};

  .flex-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .quest {
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.text2};

    display: flex;
    align-items: center;
    gap: 6px;

    b {
      color: ${({ theme }) => theme.text2};
    }

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .logo {
    height: 40px;
    width: 40px;
    min-width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: ${({ theme }) => theme.bg1};

    img {
      width: 24px;
    }
  }

  .logo-name {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;

    h3 {
      font-family: Unbounded;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 0;
      margin-top: 0;
      color: ${({ theme }) => theme.text1};
      @media (max-width: 768px) {
        font-size: 14px;
        font-weight: 400;
      }
    }

    .points {
      font-family: Unbounded;
      font-size: 16px;
      font-weight: 600;
      color: ${({ theme }) => theme.primary1};

      @media (max-width: 768px) {
        font-size: 12px;
        font-weight: 400;
      }
    }

    .resp {
      @media (max-width: 768px) {
        font-size: 8px;
        font-weight: 400;
    }
  }
`

const AccordionButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`

const LinkTo = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  text-decoration: none;
  h3,
  svg {
    transition: color 200ms;
    color: ${({ theme }) => theme.text1};
  }

  &:hover {
    h3,
    svg {
      color: ${({ theme }) => theme.text2};
    }
  }
`

const DetailsList = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  transition: max-height 300ms ease-in-out;
  max-height: ${({ isOpen }) => (isOpen ? '2000px' : '0')};
  display: flex;
  flex-direction: column;
`

const ListItemDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.text3};

  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 4px;
    padding: 16px 0 0 16px;
    border-bottom: 0;
  }

  .week {
    font-size: 14px;
    font-weight: 400;
  }
  .value {
    font-family: Unbounded;
    font-size: 14px;
    font-weight: 500;
  }

  
  }
`

const Accordion: React.FC<{ item: any }> = ({ item }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const appId = item.name
  const isHyperSwap = appId === 'HyperSwap'
  const ecosystemInfo = isHyperSwap
    ? {
        name: 'HyperSwap',
        logo: <img src={HyperswapLogo} alt="hyperswap" />,
      }
    : ecosystemList?.[appId]

  if (!ecosystemInfo) return null

  const isDisabled = ecosystemInfo?.disabled === true
  const distributionComingSoon = ecosystemInfo?.distributionSoon === true
  return (
    <Container>
      <ListItem key={ecosystemInfo?.name} onClick={() => setIsOpen(!isOpen)}>
        <div className="flex-row">
          <div className="logo-name">
            <div className="logo">{ecosystemInfo?.logo}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                {ecosystemInfo?.url ? (
                  <LinkTo href={ecosystemInfo?.url} target="_blank">
                    <h3>{ecosystemInfo?.name}</h3>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-external-link"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
                      <path d="M11 13l9 -9" />
                      <path d="M15 4h5v5" />
                    </svg>
                  </LinkTo>
                ) : (
                  <h3>{ecosystemInfo?.name}</h3>
                )}

                {isDisabled ? (
                  <>
                    <Tag variant={2}>Coming soon...</Tag>
                  </>
                ) : (
                  <>
                    {distributionComingSoon ? (
                      <Tag variant={2}>
                        <span className="resp">Distribution coming soon...</span>
                      </Tag>
                    ) : (
                      <span className="points">{item?.total} points</span>
                    )}
                  </>
                )}
              </div>
              {ecosystemInfo?.description && <div className="quest">{ecosystemInfo.description}</div>}
            </div>
          </div>
          {!isHyperSwap && item?.total > 0 && (
            <AccordionButton onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-up"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 15l6 -6l6 6" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 9l6 6l6 -6" />
                </svg>
              )}
            </AccordionButton>
          )}
        </div>
      </ListItem>

      <DetailsList isOpen={isOpen}>
        {Object.keys(item).map((key: string) => {
          if (!key.match('week')) return

          return (
            <ListItemDetail key={key}>
              <span className="week">{`Week ${key.replace('week_', '')}`}</span>{' '}
              <span className="value">{item[key]}</span>
            </ListItemDetail>
          )
        })}
      </DetailsList>
    </Container>
  )
}
export default Accordion
